import * as React from 'react';
import { useStyles } from '@sravni/react-utils';
import modules_a3dacc96 from '../styles/List.module.less.js';

/**
 * @description List item element.
 *
 * @component
 * @example
 * ```jsx
 * <ListItem>...</ListItem>
 * ```
 */
const ListItem = React.forwardRef((props, ref) => {
    const { icon, className, children, ...restProps } = props;
    const cx = useStyles(modules_a3dacc96);
    const classNames = cx(className, 'item', {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'with-icon': icon,
    });
    return (React.createElement("li", { ref: ref, className: classNames, ...restProps },
        icon ? React.createElement("span", { className: cx('icon') }, icon) : null,
        children));
});
ListItem.displayName = 'ListItem';

export { ListItem };
//# sourceMappingURL=ListItem.js.map
